{
  "nl": {
    "window": {
      "app": "App",
      "customersDashboard": "Dashboard",
      "customersDecisionDocuments": "Beslissing",
      "customersDecisionProposals": "Voorstellen",
      "customersDecisionTickets": "Beslissing",
      "customersDecisionTicketsShow": "Beslissing",
      "customersDecisions": "Beslissingen",
      "customersDocuments": "Documenten",
      "customersDocumentsAll": "Documentoverzicht",
      "customersDocumentsFolder": "Documentcategorie",
      "customersDocumentsFolders": "Documentcategorieën",
      "customersInspirationLists": "Inspiraties",
      "customersInspirationListsShow": "Inspiraties",
      "customersInstallmentTerms": "Betalingsschijven",
      "customersIssues": "Nazorg",
      "customersIssuesList": "Nazorg",
      "customersProjectInformation": "Projectinformatie",
      "customersQuestionLists": "FAQs",
      "customersQuestionListsShow": "FAQs",
      "customersRoot": "Dashboard",
      "customersRootSettingsProfile": "Instellingen",
      "customersSettingsProfile": "Instellingen",
      "customersTickets": "Gesprekken",
      "customersTicketsNew": "Nieuw Gesprek",
      "customersTicketsShow": "Gesprek",
      "employeesClientContacts": "Contacten",
      "employeesClientContactsNew": "Nieuw contact",
      "employeesClientContactsNewCustomer": "Nieuwe Klant",
      "employeesClientContactsNewEmployee": "Nieuw Teamlid",
      "employeesClientContactsNewPartner": "Nieuwe Partner",
      "employeesClientContactsType": "Contacten",
      "employeesClientDashboard": "Dashboard",
      "employeesClientProjects": "Projecten",
      "employeesClientProjectsNew": "Nieuw project",
      "employeesClientTickets": "Gesprekken",
      "employeesClientTicketsNew": "Nieuw Gesprek",
      "employeesClientTicketsShow": "Gesprek",
      "employeesMarketplace": "Marketplace",
      "employeesProjectActivity": "Activiteit",
      "employeesProjectAnnouncements": "Nieuwsoverzicht",
      "employeesProjectDecisionActivity": "Activiteit",
      "employeesProjectDecisionDocuments": "Documenten",
      "employeesProjectDecisionProposalTemplate": "Voorstelsjablonen",
      "employeesProjectDecisionProposals": "Voorstellen",
      "employeesProjectDecisionReminders": "Herinneringen",
      "employeesProjectDecisionTickets": "Gesprekken",
      "employeesProjectDecisionTicketsShow": "Gesprek",
      "employeesProjectDecisionTypeNew": "Nieuwe beslissing",
      "employeesProjectDecisionTypes": "Beslissingen",
      "employeesProjectDecisions": "Beslissingen",
      "employeesProjectDecisionsEdit": "Beslissingen",
      "employeesProjectDecisionsNew": "Nieuwe beslissing",
      "employeesProjectDocuments": "Documenten",
      "employeesProjectInformationPageActivity": "Activiteit",
      "employeesProjectInformationPageAftercare": "Nazorg",
      "employeesProjectInformationPageDecisions": "Beslissingen",
      "employeesProjectInformationPageDocuments": "Documenten",
      "employeesProjectInformationPageInformation": "Informatie",
      "employeesProjectInformationPageInstallments": "Betalingsschijven",
      "employeesProjectInformationPageLevels": "Niveaus",
      "employeesProjectInformationPageMilestones": "Mijlpalen",
      "employeesProjectInformationPageSpaces": "Ruimtes",
      "employeesProjectInformationPageSurveys": "Enquêtes",
      "employeesProjectInformationPageTasks": "Taken",
      "employeesProjectInformationPageTickets": "Gesprekken",
      "employeesProjectInstallmentGroup": "Financiën",
      "employeesProjectInstallmentGroupNew": "Nieuwe betalingsschijf",
      "employeesProjectInstallmentGroups": "Financiën",
      "employeesProjectInstallmentGroupsList": "Financiën",
      "employeesProjectInstallmentGroupsMatrix": "Afbetalingsschijven",
      "employeesProjectInstallmentNew": "Nieuwe afbetalingsschijven",
      "employeesProjectIssueListTypeIssues": "Puntenlijst - Alle punten",
      "employeesProjectIssueListTypeNew": "Nieuwe puntenlijsttype",
      "employeesProjectIssueListTypeUnits": "Puntenlijst - Unit overzicht",
      "employeesProjectIssueListTypes": "Puntenlijsten",
      "employeesProjectIssueListUnitDocuments": "Unitpunten - Documenten",
      "employeesProjectIssueListUnitIssues": "Unitpunten",
      "employeesProjectIssueListUnitTickets": "Unitpunten - Gesprekken",
      "employeesProjectIssueListUnitTicketsShow": "Gesprekken",
      "employeesProjectIssueListsNew": "Nieuwe punten",
      "employeesProjectMilestones": "Mijlpalen",
      "employeesProjectQuestionLists": "FAQs",
      "employeesProjectQuestionListsShow": "FAQ",
      "employeesProjectSalesUnits": "Verkoop",
      "employeesProjectSurveySummary": "Enquête",
      "employeesProjectSurveyTypes": "Enquêtes",
      "employeesProjectSurveys": "Enquête",
      "employeesProjectTickets": "Gesprekken",
      "employeesProjectTicketsEmailConversations": "E-mails",
      "employeesProjectTicketsEmailConversationsShow": "E-mail",
      "employeesProjectTicketsNew": "Nieuw Gesprek",
      "employeesProjectTicketsShow": "Gesprekken",
      "employeesProjectTodoLists": "Taken",
      "employeesSettingsClientAftercare": "Nazorg",
      "employeesSettingsClientInformation": "Admin",
      "employeesSettingsClientIntegrations": "Integraties",
      "employeesSettingsProfile": "Profiel",
      "level": "Level",
      "mployeesProjectInstallmentGroups": "Financiën",
      "partnersClientProjects": "Projecten",
      "partnersProjectDecisionDocuments": "Documenten",
      "partnersProjectDecisionProposals": "Voorstellen",
      "partnersProjectDecisionTickets": "Gesprekken",
      "partnersProjectDecisionTicketsShow": "Gesprek",
      "partnersProjectDecisionTypesItems": "Beslissingen",
      "partnersProjectDecisions": "Beslissingen",
      "partnersProjectDocuments": "Documenten",
      "partnersProjectDocumentsUnit": "Documenten",
      "partnersProjectIssueListTypeIssues": "Puntenlijst - Alle punten",
      "partnersProjectIssueListTypeUnits": "Puntenlijst - Unit overzicht",
      "partnersProjectIssueListTypes": "Puntenlijsten",
      "partnersProjectIssueListUnitDocuments": "Unitpunten - Documenten",
      "partnersProjectIssueListUnitIssues": "Unitpunten",
      "partnersProjectIssueListUnitTickets": "Unitpunten - Gesprekken",
      "partnersSettingsProfile": "Profile",
      "root": "App"
    }
  }
}